import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../redux/modals/action';
import Modal from '../../layout/modal/Modal';
import EditIcon from '@mui/icons-material/Edit';
import styles from './ReviewApsModal.module.scss';
import { Grid } from '@mui/material';
import { goToStep } from '../../../redux/agreement/actions';
import { numberWithCommas } from '../../../utils/numberWithCommas';
import CustomButton from '../../layout/customButton/CustomButton';
import Reviewheader from './ReviewHeader/ReviewHeader';
import ReviewContent from './ReviewContent/ReviewContent';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { useState } from 'react';
import saveAgreementData from '../../../api/Agreement/saveAgreementData.api';
import { useParams } from 'react-router';
import { setDepositSchedule } from '../../../api/Agreement/setDepositSchedule.api';
import PurchaserInformation from './ReviewContent/PurchaserInformation/PurchaserInformation';
import ProductInformation from './ReviewContent/ProductInformation/ProductInformation';
import Pricing from './ReviewContent/Pricing/Pricing';
import { useReactToPrint } from 'react-to-print';
import { ReactComponent as PrintIcon } from '../../../assets/icons/PrintIcon.svg';
import { ReactComponent as GreyPrintIcon } from '../../../assets/icons/GreyPrintIcon.svg';
import { checkEmptyRequiredFields } from '../../../utils/checkForValueInJson';
import _ from 'lodash';
import { setAlert } from '../../../redux/alerts/action';
import { getDepositScheduleAPI } from '../../../redux/agreement/actions';

const ReviewApsModal = ({
	// parent props
	openModal,
	handleSignDocument,
	viewOnly,
	// redux
	closeModal,
	closeReviewApsModal,
	goToStep,
	clientInfo,
	productAvailability,
	options,
	totalPrice,
	individuals,
	corporate,
	setAlert,
	leadId,
	getDepositScheduleAPI,
}) => {
	const [editMode, setEditMode] = useState(false);
	const [purchaserInformation, setPurchaserInformation] = useState({});
	const [tabSelected, setTabSelected] = useState(0);
	const [depositScheduleData, setDepositScheduleData] = useState({});
	const [saveEditOnPrice, setSaveEditOnPrice] = useState(false);
	const [error, setError] = useState({});
	var param = useParams();

	const componentRef = useRef();

	// const handleDownloadPdf = () => {
	// 	// const input = document.getElementById('divToPrint');
	// 	// html2canvas(input, {
	// 	// 	scale: 0.48, // use the desired scale
	// 	// 	allowTaint: true,
	// 	// 	useCORS: true,
	// 	// }).then((canvas) => {
	// 	// 	const imgData = canvas.toDataURL('image/png');
	// 	// 	const pdf = new jspdf();
	// 	// 	pdf.addImage(imgData, 'JPEG', 0, 0);
	// 	// 	pdf.save('download.pdf');
	// 	// });

	// };
	const handleDownloadPdf = useReactToPrint({
		content: () => componentRef.current,
	});

	const handleSaveDocument = () => {
		if (tabSelected === 0 && individuals) {
			let keys =
				purchaserInformation && Object.keys(purchaserInformation);
			let err = {};
			keys?.map((key) => {
				let chkFields = checkEmptyRequiredFields(
					purchaserInformation[key],
					null
				);
				if (!_.isEmpty(chkFields) || !_.isEmpty(error[key])) {
					let combinedErr = Object.assign(chkFields, error[key]);
					err[key] = combinedErr;
				}
			});
			setError(err);
			if (_.isEmpty(err) === true) {
				saveAgreementData(param.id, 'individual', purchaserInformation);
				setEditMode(false);
				setAlert('success', 'Save changes successfully.');
			}
		} else if (tabSelected === 0) {
			let chkFields = checkEmptyRequiredFields(
				purchaserInformation,
				null
			);
			if (_.isEmpty(chkFields) && _.isEmpty(error)) {
				saveAgreementData(
					param.id,
					'corporation',
					purchaserInformation
				);
				setEditMode(false);
				setAlert('success', 'Save changes successfully.');
			} else {
				let combinedErr = Object.assign(chkFields, error);
				setError(combinedErr);
			}
		} else if (tabSelected === 2) {
			if (saveEditOnPrice) {
				setDepositSchedule(param.id, depositScheduleData);
				setSaveEditOnPrice(false);
				setEditMode(false);
				getDepositScheduleAPI(param.id);
			}
		}
	};
	useEffect(() => {
		setError({});
	}, [openModal]);

	const closeReviewModal = () => {
		if (viewOnly && leadId) {
			closeReviewApsModal(leadId);
		} else {
			closeModal('reviewAps');
		}
	};
	return (
		<Modal
			show={openModal}
			close={closeReviewModal}
			includeClose={false}
			bodyHeight={'85vh'}
			bodyMaxHeight={'100%'}
		>
			<div className={styles.reviewWrapper}>
				<Reviewheader closeReviewModal={closeReviewModal} />
				<ReviewContent
					viewOnly={viewOnly}
					editMode={editMode}
					setEditMode={setEditMode}
					purchaserInformation={purchaserInformation}
					setPurchaserInformation={setPurchaserInformation}
					tabSelected={tabSelected}
					setTabSelected={setTabSelected}
					depositScheduleData={depositScheduleData}
					setDepositScheduleData={setDepositScheduleData}
					saveEditOnPrice={saveEditOnPrice}
					setSaveEditOnPrice={setSaveEditOnPrice}
					error={error}
					setError={setError}
				/>
				<div className={styles.review_footer}>
					<Grid container justifyContent='space-between'>
						<Grid item>
							<div
								className={`${styles.print_button} ${
									editMode && styles.disabled
								}`}
							>
								<div className={styles.print_icon}>
									{editMode ? (
										<GreyPrintIcon />
									) : (
										<PrintIcon />
									)}
								</div>

								<div
									className={styles.print_text}
									onClick={handleDownloadPdf}
								>
									Print Document
								</div>
							</div>
						</Grid>
						<Grid item>
							<div className={styles.signDocBtn}>
								{editMode && (
									<div
										onClick={() => {
											setEditMode(false);
										}}
										height={42}
										width={200}
										className={styles.cancel_btn}
									>
										Cancel
									</div>
								)}
								{viewOnly === false && (
									<CustomButton
										onClick={() => {
											editMode === false
												? handleSignDocument()
												: handleSaveDocument();
										}}
										height={42}
										width={200}
									>
										{editMode === true
											? 'Save'
											: 'Create Agreement'}
									</CustomButton>
								)}
							</div>
						</Grid>
					</Grid>
				</div>
				{/* div to be converted to pdf */}
				<div
					className={`${styles.review_content_wrapper} ${styles.to_print}`}
					id={'divToPrint'}
					style={{ display: 'none', overflow: 'hidden' }}
				>
					<div
						ref={componentRef}
						style={{
							overflow: 'hidden',
							padding: '20px',
						}}
					>
						<Reviewheader toPrint />
						<br />
						<hr className={styles.separator} />
						<br />

						<div className={styles.main_content}>
							<PurchaserInformation
								purchaserInformation={purchaserInformation}
								setPurchaserInformation={
									setPurchaserInformation
								}
								error={error}
								setError={setError}
							/>
							<br />
							<ProductInformation printMode />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<Pricing
								editMode={editMode}
								depositScheduleData={depositScheduleData}
								setDepositScheduleData={setDepositScheduleData}
								saveEditOnPrice={saveEditOnPrice}
								setSaveEditOnPrice={setSaveEditOnPrice}
								printMode
							/>
						</div>
					</div>
				</div>
				{/* ------- */}
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	leadId: state.agreement?.agreementById?.leadDetails?.leadId,
	individuals: state.agreement?.agreementById?.clientInfo?.individual,
	corporate: state.agreement?.agreementById?.clientInfo?.corporation,
	clientInfo:
		state.agreement.agreementById?.clientInfo || state.agreement.clientInfo,
	productAvailability: state.agreement.agreementById?.productAvailability,
	options: state.agreement?.agreementById?.options,
	totalPrice:
		+Number(state.agreement.agreementById?.productAvailability?.lotPrice) +
			+Number(
				state.agreement.agreementById?.productAvailability?.elevation
					?.price
			) +
			Number(
				state.agreement.agreementById?.productAvailability?.upgrade
					?.price
			) +
			Number(
				state.agreement.agreementById?.productAvailability?.grade?.price
			) +
			+Number(state.agreement.agreementById?.totalOptions || 0) ||
		+Number(state.agreement.productAvailability.lotPrice) +
			+Number(state.agreement?.productAvailability?.elevation?.price) +
			Number(state.agreement?.productAvailability?.upgrade?.price) +
			Number(state.agreement?.productAvailability?.grade?.price) +
			+Number(state.agreement?.totalOptions || 0),
});

export default connect(mapStateToProps, {
	closeModal,
	goToStep,
	setAlert,
	getDepositScheduleAPI,
})(ReviewApsModal);
